# list of active flags in Thomas, please list it here
defaultFlags = {
}

injectedFlags = window?.__?.featureFlags ? {}
# 
# { [flagKey: string]: boolean}
# 
module.exports = Object.assign(defaultFlags, injectedFlags)